// extracted by mini-css-extract-plugin
module.exports = {"arrowContainer":"arrowPaginated_arrowContainer__2QYjp","prev":"arrowPaginated_prev__3HRzM","next":"arrowPaginated_next__3U3qC","pagination":"arrowPaginated_pagination__1onsl","img":"arrowPaginated_img__4rV33"};
    if(module.hot) {
      // 1746134883200
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  